"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAudioDeviceManagerDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const IAudioDeviceManagerImpl_1 = require("../impl/IAudioDeviceManagerImpl");
const AgoraConsole_1 = require("../util/AgoraConsole");
class IAudioDeviceManagerDispatch {
    constructor(engine) {
        this._impl = new IAudioDeviceManagerImpl_1.IAudioDeviceManagerImpl(engine);
        this._engine = engine;
    }
    // @ts-ignore
    enumeratePlaybackDevices() {
        return this._impl.enumeratePlaybackDevices();
    }
    // @ts-ignore
    enumerateRecordingDevices() {
        return this._impl.enumerateRecordingDevices();
    }
    // @ts-ignore
    setPlaybackDevice_4ad5f6e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let deviceId = obj.deviceId;
        if (deviceId === undefined) {
            AgoraConsole_1.AgoraConsole.error('deviceId is undefined');
            throw 'deviceId is undefined';
        }
        return this._impl.setPlaybackDevice_4ad5f6e(deviceId);
    }
    // @ts-ignore
    getPlaybackDevice_73b9872(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let deviceId = obj.deviceId;
        return this._impl.getPlaybackDevice_73b9872();
    }
    // @ts-ignore
    getPlaybackDeviceInfo_5540658() {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getPlaybackDeviceInfo_5540658 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlaybackDeviceInfo_ed3a96d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getPlaybackDeviceInfo_ed3a96d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlaybackDeviceVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_setPlaybackDeviceVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlaybackDeviceVolume_915cb25(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getPlaybackDeviceVolume_915cb25 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRecordingDevice_4ad5f6e(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let deviceId = obj.deviceId;
        if (deviceId === undefined) {
            AgoraConsole_1.AgoraConsole.error('deviceId is undefined');
            throw 'deviceId is undefined';
        }
        return this._impl.setRecordingDevice_4ad5f6e(deviceId);
    }
    // @ts-ignore
    getRecordingDevice_73b9872(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let deviceId = obj.deviceId;
        return this._impl.getRecordingDevice_73b9872();
    }
    // @ts-ignore
    getRecordingDeviceInfo_5540658() {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getRecordingDeviceInfo_5540658 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getRecordingDeviceInfo_ed3a96d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getRecordingDeviceInfo_ed3a96d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRecordingDeviceVolume_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_setRecordingDeviceVolume_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getRecordingDeviceVolume_915cb25(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getRecordingDeviceVolume_915cb25 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setLoopbackDevice_4ad5f6e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_setLoopbackDevice_4ad5f6e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getLoopbackDevice_73b9872(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getLoopbackDevice_73b9872 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlaybackDeviceMute_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_setPlaybackDeviceMute_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getPlaybackDeviceMute_d942327(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getPlaybackDeviceMute_d942327 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRecordingDeviceMute_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_setRecordingDeviceMute_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    getRecordingDeviceMute_d942327(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_getRecordingDeviceMute_d942327 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startPlaybackDeviceTest_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_startPlaybackDeviceTest_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopPlaybackDeviceTest() {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_stopPlaybackDeviceTest not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startRecordingDeviceTest_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_startRecordingDeviceTest_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopRecordingDeviceTest() {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_stopRecordingDeviceTest not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    startAudioDeviceLoopbackTest_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_startAudioDeviceLoopbackTest_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    stopAudioDeviceLoopbackTest() {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_stopAudioDeviceLoopbackTest not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    followSystemPlaybackDevice_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_followSystemPlaybackDevice_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    followSystemRecordingDevice_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_followSystemRecordingDevice_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    followSystemLoopbackDevice_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('AudioDeviceManager_followSystemLoopbackDevice_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    release() {
        return this._impl.release();
    }
}
exports.IAudioDeviceManagerDispatch = IAudioDeviceManagerDispatch;
